import { USER_PRIVACY_SETTINGS_TYPES } from 'reducers/userPrivacy/userPrivacy';
import { PRIVACY_VISIBILITY_OPTIONS } from 'utils/PrivacyUtils';
import AnalyticsUtil from 'utils/AnalyticsUtil';

/**
 * privacyItems :
 *  [
 *      {
 *          privacyType: '',
 *          newAccessRule: ''
 *      },
 *      ...
 *  ]
 *
 * subCategoryAccessRules :
 *
 *      {
 *          privacyType: {
 *              fields: [
 *                  {field: value},
 *                  ...
 *              ]
 *          },
 *          ...
 *
 *      }
 *
 *
 */

export const generateUpdatedUserPrivacySettings = (
    userPrivacyDataWithCustomValues,
    privacyItems,
    subCategoryAccessRules
) => {
    const subCategoryAccessRule = (privacyItem, subItem) => {
        if (privacyItem.newAccessRule === PRIVACY_VISIBILITY_OPTIONS.CUSTOM) {
            if (
                subCategoryAccessRules &&
                subCategoryAccessRules[privacyItem.privacyType] &&
                subCategoryAccessRules[privacyItem.privacyType].fields &&
                subCategoryAccessRules[privacyItem.privacyType].fields[subItem.privacySubcategoryType]
            ) {
                return subCategoryAccessRules[privacyItem.privacyType].fields[subItem.privacySubcategoryType];
            } else {
                return userPrivacyDataWithCustomValues[privacyItem.privacyType].subcategoryPrivacySettings.find(
                    (subCategory) => subCategory.privacySubcategoryType === subItem.privacySubcategoryType
                ).subcategoryDetails.accessRule;
            }
        }

        return privacyItem.newAccessRule;
    };

    const allSubcategoryPrivacySettings = (privacyItem) => {
        return userPrivacyDataWithCustomValues[privacyItem.privacyType].subcategoryPrivacySettings.map((item) => {
            return {
                ...item,
                subcategoryDetails: {
                    ...item.subcategoryDetails,
                    accessRule: subCategoryAccessRule(privacyItem, item)
                }
            };
        });
    };

    const updatedObject = {};

    privacyItems.forEach((privacyItem) => {
        updatedObject[privacyItem.privacyType] = {
            ...userPrivacyDataWithCustomValues[privacyItem.privacyType],
            categoryDetails: {
                ...userPrivacyDataWithCustomValues[privacyItem.privacyType].categoryDetails,
                categoryAccessRule: privacyItem.newAccessRule
            },
            subcategoryPrivacySettings: allSubcategoryPrivacySettings(privacyItem)
        };
    });

    const updatedPayload = {
        ...userPrivacyDataWithCustomValues,
        ...updatedObject
    };

    return updatedPayload;
};

export const pushUserPrivacySettingsChangeEventToAnalytics = (action, label) => {
    AnalyticsUtil.push({
        event: 'track_event',
        category: 'User Privacy Settings Changed Events',
        action: action,
        label: label
    });
};

export const PRIVACY_SETTINGS_ANALYTICS = {
    ACTIVITY_PRIVACY_SETTINGS_CHANGED: 'User Changed Activity Privacy Settings',
    USER_PROFILE_PRIVACY_SETTINGS_CHANGED: 'User Profile Privacy Settings',
    PAST_ACTIVITY_PRIVACY_SETTINGS_CHANGED: 'User Changed Past Activity Privacy Settings',
    STEPS_PRIVACY_SETTINGS_CHANGED: 'User Changed Steps Privacy Settings',
    BADGES_PRIVACY_SETTINGS_CHANGED: 'User Changed Badges Privacy Settings',
    SINGLE_ACTIVITY_PRIVACY_SETTINGS_CHANGED: 'User Changed The Privacy For a Specific Single Activity'
};
